import { Model, Schema } from "src/engine/modules/model/classes"
import { denormalizeResource } from "src/models/resource"
import memoize from "lodash/memoize"

const entityName = `eventResources`

export default memoize(
  eventUuid =>
    new Model({
      // Model name is used as a key in collection selectors,
      // so `eventUuid` is ignored when selecting data
      // (but used when fetching the data), so wrong
      // data may be selected if we use just `entityName` as
      // a model name.
      name: `${entityName}_${eventUuid}`,
      getRestUrn: () => `/events/${eventUuid}/resources`,
      primaryKey: `uuid`,
      denormalize: denormalizeResource,
      schema: new Schema({}),
    }),
)
